// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import Datatable from 'vue2-datatable-component';
import * as uiv from 'uiv';
import * as components from './components';
import App from './App';
import CrossdockApp from './CrossdockApp';
import apollo from './apollo';

Vue.use(uiv);
Vue.use(VueApollo);
Vue.use(Datatable);

// Globally register all custom components
Object.keys(components).forEach((key) => {
  Vue.component(key, components[key]);
});

Vue.config.productionTip = false;

let vm = null;

let renderable = {
  App,
  CrossdockApp,
};

const renderTo = (app, el) => {
  if (!app in renderable) {
    throw new Error(`Invalid app: '${app}'`);
  }

  if (!el) {
    throw new Error('Please provide an element to render to.');
  }

  if (typeof el !== 'string' && !(el instanceof HTMLElement)) {
    throw new Error(
      'Element must be either a string (css selector) or HTMLElement'
    );
  }

  if (typeof el === 'string' && !document.querySelector(el)) {
    throw new Error(
      [
        `Cannot find an element that matches the given selector "${el}".`,
        'If this is unexpected, consider providing an HTMLElement instead.',
      ].join(' ')
    );
  }

  vm = new Vue({
    el: el,
    components: {
      [app]: renderable[app],
    },
    provide: apollo.provide(),
    template: `<${app}/>`,
  });
};

export { vm, renderTo };



// WEBPACK FOOTER //
// ./src/main.js